class PermitExtensions extends Array {}

const permit_extension_api_adapter = permitExtension => {
    return permitExtension;
};

const permit_extensions_api_adapter = permitExtensions => {
    return permitExtensions.map(permit_extension_api_adapter);
};

const permit_extension_view_adapter = permitExtension => {
    // in front-end falsy values are "" or undefined or null
    // we must destructure object before its adaptation because
    // nested objects are still inmutable inside permitExtension object
    if (permitExtension["permit"]) {
        permitExtension["permit_id"] = permitExtension["permit"].id;
    }
    if (!permitExtension["types"]) permitExtension["types"] = [];
    permitExtension["is_signed"] = !!permitExtension["is_signed"];

    delete permitExtension["permit"];
    delete permitExtension["folder"];
    delete permitExtension["created_by"];
    delete permitExtension["updated_by"];
    delete permitExtension["created_at"];
    delete permitExtension["updated_at"];

    return permitExtension;
};

const createPermitExtensions = (data = []) => {
    const permitExtensions = PermitExtensions.from(data, permitExtension =>
        createPermitExtension(permitExtension)
    );
    return permitExtensions;
};

const createPermitExtension = ({
    id = -1,
    code = null,
    on_date = null,
    application_date = null,
    island = null,
    district = null,
    is_total = null,
    status = "",
    felling = null,
    cutting = null,
    clearing = null,
    transport = null,
    felling_start_date = null,
    felling_end_date = null,
    felling_price = null,
    cutting_start_date = null,
    cutting_end_date = null,
    cutting_price = null,
    clearing_start_date = null,
    clearing_end_date = null,
    clearing_area = null,
    clearing_price = null,
    transport_start_date = null,
    transport_end_date = null,
    transport_price = null,
    types = null,
    types_label = "",
    technical_decision = null,
    is_signed = null,
    fee_type = null,
    fee_amount = null,
    comments = null,
    technical_comments = null,
    invoice_sent = null,
    extension_sent = null,
    extension_signed = null,
    printed_extension = null,
    printed_invoice = null,
    permit = null,
    holder = null,
    tree_set = [],
    material_set = [],
    plot = null,
    folder = "",
    featured_document = null,
    created_by = "",
    updated_by = "",
    created_at = null,
    updated_at = null,
} = {}) => {
    const publicApi = {
        id,
        code,
        on_date,
        application_date,
        island,
        district,
        is_total,
        status,
        felling,
        cutting,
        clearing,
        transport,
        felling_start_date,
        felling_end_date,
        felling_price,
        cutting_start_date,
        cutting_end_date,
        cutting_price,
        clearing_start_date,
        clearing_end_date,
        clearing_area,
        clearing_price,
        transport_start_date,
        transport_end_date,
        transport_price,
        types,
        types_label,
        technical_decision,
        is_signed,
        fee_type,
        fee_amount,
        comments,
        technical_comments,
        invoice_sent,
        extension_sent,
        extension_signed,
        printed_extension,
        printed_invoice,
        permit,
        holder,
        tree_set,
        material_set,
        plot,
        folder,
        featured_document,
        created_by,
        updated_by,
        created_at,
        updated_at,
    };

    return Object.freeze(publicApi);
};

export {
    createPermitExtension as default,
    createPermitExtensions,
    permit_extension_api_adapter,
    permit_extensions_api_adapter,
    permit_extension_view_adapter,
};
